import React, { useEffect } from "react";
import RegionMenu from 'components/menu/RegionMenu';
import ParametersMenu from 'components/menu/ParametersMenu';
import ObservationsMenu from 'components/menu/ObservationsMenu';
import MetricsMenu from 'components/menu/MetricsMenu';
import ProductSearch from 'components/controls/ProductSearch';
import { useSelector } from 'react-redux';

import {LineSeparator, BlankSeparator} from 'components/controls/Separators';
import 'styles/main/Menu.sass'
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';

export default function Menu(props) {
  const observations = useSelector((state) => state.observations);


  useEffect(() => { 
    console.log('render Menu')
  });

  function clickButton() {
    var menuButton = document.getElementById('menuB') //No uso variables de estado para evitar que react redibuje el menu
    if (menuButton.classList.contains("menuBExpanded")){
      menuButton.classList.remove("menuBExpanded")
      document.getElementById('menu').classList.remove('menuExpanded')
      document.getElementById('fixedMenu').classList.remove('menuExpanded')
      setTimeout(() => document.getElementById('fixedMenu').style.opacity = 0, 400);

    } else {
      menuButton.classList.add("menuBExpanded")
      document.getElementById('menu').classList.add('menuExpanded')
      document.getElementById('fixedMenu').classList.add('menuExpanded')
      setTimeout(() => document.getElementById('fixedMenu').style.opacity = 1, 300);
    }
    setTimeout(() => window.dispatchEvent(new Event('resize')), 1000);  
  }

  function closeMenus(){
    for (var item of document.getElementsByClassName('selMenu')){
      item.style.display = 'none'
    }
    document.getElementById("setMinHeight").style["min-height"] = "0px"
  }

  return (
    <div className="cell menuExpanded" id="menu" onClick={closeMenus}>
      <div id="menuB"  className="menuBExpanded" onClick={clickButton}>
        <div id="menuBC"></div>
      </div>
      <div id="fixedMenu" className="menuExpanded">
        <SimpleBar autoHide={false} style={{ height: "100%" }}>
          <div id="setMinHeight">
            <RegionMenu />
            <LineSeparator/>
            <ParametersMenu/>
            <LineSeparator />
            <ObservationsMenu/>
            {!observations && (
            <div>
              <LineSeparator />
              <MetricsMenu />
              <BlankSeparator />
            </div>
            )}
          </div>
        </SimpleBar>
      </div>
    </div>
  )
}